// Bundle Builder v1 — build-time feature flag. Mirrors the File Snap /
// ComplianceMinder pattern: the new basket, upload and export surfaces are
// hidden unless this is "true". The live Brief 91 search stays un-flagged.
// Backend gate: BUNDLE_BUILDER_ENABLED (default off).
export const BUNDLE_BUILDER_ENABLED =
  process.env.REACT_APP_BUNDLE_BUILDER_ENABLED === "true";
